import { render } from "./DayCard.vue?vue&type=template&id=33ace69d&ts=true"
import script from "./DayCard.vue?vue&type=script&lang=ts"
export * from "./DayCard.vue?vue&type=script&lang=ts"

import "./DayCard.vue?vue&type=style&index=0&id=33ace69d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__